import { render, staticRenderFns } from "./CustomerLaunch.vue?vue&type=template&id=036d6604&scoped=true"
import script from "./CustomerLaunch.vue?vue&type=script&lang=js"
export * from "./CustomerLaunch.vue?vue&type=script&lang=js"
import style0 from "./CustomerLaunch.vue?vue&type=style&index=0&id=036d6604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d6604",
  null
  
)

export default component.exports